import { gql } from "@apollo/client";

// Newest ASSET_REMOVE event of an asset — the event a declaration of
// contamination attaches to right after the removal / exchange wizard.
export const LatestAssetRemoveEvent = gql`
    query LatestAssetRemoveEvent ($assetId: ID!) {
        installedBaseEventList (filter: { assetId: { equals: $assetId }, eventType: { equals: ASSET_REMOVE } }) {
            installedBaseEvents (pagination: { limit: 1 }, sort: { insert: desc }) {
                id
                insert
            }
        }
    }
`;
